import { NoonReportStatusBM } from "../../types/BusinessModel/Aol/NoonReportStatusBM";
import { NoonReportStatus } from "../../types/ViewModel/Aol/NoonReportStatus";

export const createNoonReportStatus = (noonReportStatusBM: NoonReportStatusBM): NoonReportStatus => {
    return {
        noonReportId: noonReportStatusBM.noonReportId,
        noonReportDate: noonReportStatusBM.noonReportDate,
        lastUpdatedUtc: noonReportStatusBM.lastUpdatedUtc,
        aolCompletedUtc: noonReportStatusBM.aolCompletedUtc,
        aolApprovedUtc: noonReportStatusBM.aolApprovedUtc,
        isAolComplete: noonReportStatusBM.isAolComplete,
        isAolApproved: noonReportStatusBM.isAolApproved,
    };
};

export const createNoonReportStatusList = (noonReportStatus: NoonReportStatusBM[]) => noonReportStatus.map((noonReportStatus) => createNoonReportStatus(noonReportStatus));
